import { alpha } from '@mui/material';
import styled from 'styled-components';

export const NodeUpdate = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 20px;
  background-color: ${({ theme }) => alpha(theme.telnyx.yellow, 0.4)};
  gap: 1rem;

  & .MuiChip-root {
    height: 28px;
  }

  p {
    font-size: 12px;
    font-weight: 400;
    margin: 0;
    color: black;
  }

  svg {
    color: black;
  }

  & .MuiIconButton-root {
    background-color: ${alpha('#000000', 0.06)};
  }

  & .MuiIconButton-root:hover {
    background-color: ${alpha('#ffffff', 0.4)} !important;
  }
`;
